<app-spinner></app-spinner>

<div class="row mx-auto bg-white rounded mb-5 maindiv" style="box-shadow: 0 2px 4px #00000029,0 4px 24px #00000014;"
     *ngIf="this.job !== undefined">
  <h1>{{ job!.title }}</h1>

  <span class="text-end">Veröffentlicht am {{ Utils.getDateFormated(job!.publishing_date) }}</span>

  <div class="row mx-auto mt-5 w-90">
    <span class="col-md-6 border-start border-bottom fs-5 align-items-center d-flex">
      <fa-icon class="fa-2x me-2" [icon]="mapmarker"></fa-icon>
      {{ job!.zipcode + ", " + job!.city + (job!.district ? " - " + job!.district : "") }}
    </span>
    <span class="col-md-6 border-bottom border-start align-items-center d-flex">
              <fa-icon class="fa-2x me-2" [icon]="publishingdate"></fa-icon>
     <span class="fs-5"> {{ Utils.getDateFormated(job!.start_date) }}</span>
    </span>
    <span class="col-md-6 border-start border-bottom mb-2 mt-2 align-items-center d-flex">
          <fa-icon class="fa-2x me-2" [icon]="calendar"></fa-icon>
            <span class="fs-5">{{ job!.timemodel ? " Vollzeit" : " Teilzeit" }}</span>
        </span>
    <span class="col-md-6 border-start border-bottom mb-2 mt-2 align-items-center d-flex">
        <fa-icon class="fa-2x me-2" [icon]="briefcase"></fa-icon>
      <span class="fs-5"> {{ Utils.getJobType(job!.contract_type) }}</span>
      </span>

    <span class="col-md-6 border-start border-bottom align-items-center d-flex">
          <fa-icon class="fa-2x me-2" [icon]="industry"></fa-icon>
           <span class="fs-5"> {{ job!.industry_name }}</span>
        </span>

    <span class="col-md-6 border-start border-bottom align-items-center d-flex">
      <fa-icon class="fa-2x me-2" [icon]="salary"></fa-icon>
      <span class="fs-5"> {{ job!.salary ? job!.salary : "n.V." }}</span>
    </span>

  </div>

  <div class="pt-5">

    <p [innerHTML]="job!.description + '<br/><br/>' | safeHtml"></p>

    <h2 *ngIf="this.job!.requirements" class="pt-3">Anforderungen an Sie</h2>
    <div>
      <ul>
        <li *ngFor="let requirement of job!.requirements">{{ requirement }}</li>
      </ul>
    </div>

    <h2 *ngIf="this.job!.requirements" class="pt-3">Perspektiven</h2>
    <div>
      <ul>
        <li *ngFor="let perspective of job!.perspectives">{{ perspective }}</li>
      </ul>
    </div>

    <h2 *ngIf="this.job!.requirements" class="pt-3">Ihre Aufgaben</h2>
    <div>
      <ul>
        <li *ngFor="let task of job!.tasks">{{ task }}</li>
      </ul>
    </div>

    <h3 class="pt-3">Bereit, Ihre Träume mit uns zu verwirklichen?</h3>
    <p>Möchten Sie Ihre Träume gemeinsam mit uns Wirklichkeit werden lassen? Dann können Sie sich per E-Mail an die
      angegebene E-Mail Adresse bewerben.</p>

    <a class="mt-" href="mailto:bewerbung@i-logistix.de?subject=Bewerbung%20für%20Job%20{{job!.uuid }}">
      <button style="color: #00C851; border: solid 2px lightgrey;" type="button"
              class="btn text-uppercase border btn-lg w-100"><strong>Jetzt per Mail Bewerben</strong></button>
    </a>

    <p class="pt-3">Job ID: {{ job!.uuid }}</p>
  </div>
</div>

<div class="row w-75 mx-auto text-center p-5" *ngIf="this.apierror">
  <h1>Aktuell können leider keine Daten empfangen werden, bitte probieren Sie es später erneut</h1>
</div>
